<template>
	<div class="comp">
		<div class="grid settings comp-inner">
			<div class="grid header">
				<div class="grid sectiontitle"><span @click="show('dashboard')"><unicon name="arrow-left" height="32" width="32" /></span> Broadcast</div>
				<div class="grid settings">
			<!-- <transition name="slide-fade">
				<button @click="save()" v-if="changes" class="btn green" v-loading="hotelloading"><unicon name="save" fill="#fff" /> salva modifiche</button>
			</transition> -->
			<button @click="openmenu()" class="btn"><i class="fas fa-bars"></i></button>
				</div>
			</div>

			<!-- {{guests}} -->

			<div class="grid" style="grid-template-columns: 1fr 1fr; grid-column-gap: 128px; align-content: start;" v-if="guests.length > 0">

				<div class="grid box" style="align-content: start; grid-row-gap: 32px;">
					<div class="grid header">
						<span class="grid title">Ospiti in spiaggia con pass installato su wallet</span>
					</div>
					<div class="grid body" style="align-content: start; grid-row-gap: 12px;">
						<div v-for="(guest, index) in guests" :key="index">
							{{guest.name}}
						</div>
					</div>
				</div>
				
				<div class="grid box">
					<el-input
						type="textarea"
						:rows="12"
						placeholder="Messaggio Broadcast"
						v-model="broadcastmessage">
					</el-input>

					<div class="grid btnlist" key="btnlist">
						<button class="btn" @click="show('dashboard')"><unicon name="times" height="16" width="16" fill="#333"  /></button>
						<button class="btn green" @click="sendMessage">Manda messaggio</button>
					</div>
				</div>

			</div>

			<div v-else>
				<h2>Al momento non hai ospiti in spiaggia con pass sul wallet</h2>
			</div>

		</div>
	</div>

</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import helper from '../Mixins/helper'
export default {
	name: 'Broadcast',
	mixins: [helper],
	props: {
		// hotel: Object
	},
	data () {
	return {
		changes: false,
		broadcastmessage: ''
	}
	},
	methods: {
		sendMessage () {
			this.$store.dispatch('guests/sendPushMessages', {message: this.broadcastmessage}).then(() => {
				console.log('done')
			})
		},
		show (section) {
			console.log(section)
			this.$emit('open', section)
		},
		save () {
			console.log('save')
			// this.$store.dispatch('hotels/updateHotel', this.hotel)
		}
	},
	filters: {

	},
	watch: {

	},
	computed: {
		guests () {
			var self = this
			var guests = _.filter(this.$store.state.guests.guests, function (g) {
				var present = _.some(g.ombrelloni, function (o) { return moment().isBetween(moment(o.arrival, ['YYYY-MM-DD', 'DD.MM.YYYY']), moment(o.departure, ['YYYY-MM-DD', 'DD.MM.YYYY']), 'day', '[]') })
				// console.log(g.name, g.passid.length, moment().isBetween(moment(g.stay.start, ['YYYY-MM-DD', 'DD.MM.YYYY']), moment(g.stay.end, ['YYYY-MM-DD', 'DD.MM.YYYY']), 'day', '[]'), g.stay, present)
				// present && g.passid.length > 0 ? g.pushToken = _.find(self.$store.state.guests.passes, {'_id': g.passid}).pushToken : ''
				var haspushToken = _.find(self.$store.state.guests.passes, {'_id': g.passid})?.pushToken || false
				// console.log(haspushToken)
				return present && g.passid.length > 0 && haspushToken
				// return g.passid
			})
			// console.log('guests ', guests)
			return guests
		}
	},
	beforeMount () {

	},
	beforeDestroy () {

	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fade-enter-active {
	transition: opacity .5s;
}
.fade-leave-active {
	transition: opacity 0s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
	transition: all .3s ease;
}
.slide-fade-leave-active {
	transition: all 0s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateY(10px);
	opacity: 0;
}
</style>
